import { Form, Input, Col } from "antd";
import React, { Component } from "react";
import I18n from "../../i18n/index";
import ContentBox from "../../components/layout/ContentBox";
import store,{ ReducerKeys} from "../../reducers/index";
import {changePassword} from "../../actions/UserAction";

const FormItem = Form.Item;

class FormAccountAdmin extends Component {
    state = {
    	confirmDirty: false,
    };
    handleSubmit = (e) => {
    	e.preventDefault();
    	this.props.form.validateFields((err, values) => {
    		if (!err) {
    			changePassword({ password_old :  values.oldpassword, password : values.newpassword , password_confirmation : values.confirmpassword })
    				.then(res=> {
    					this.props.form.resetFields();

    				});
    			// console.log('Received values of form: ', values);
    		}
    	});
    }
    handleConfirmBlur = (e) => {
    	const value = e.target.value;
    	this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }
    checkPassword = (rule, value, callback) => {
    	const form = this.props.form;
    	if (value && value !== form.getFieldValue("newpassword")) {
    		callback("Two passwords that you enter isn't match!");
    	} else {
    		callback();
    	}
    }
    checkConfirm = (rule, value, callback) => {
    	const form = this.props.form;
    	if (value && this.state.confirmDirty) {
    		form.validateFields(["confirmpassword"], { force: true });
    	}
    	callback();
    }
    handleReset = () => {
    	this.props.form.resetFields();
    }

    render() {
    	const { getFieldDecorator } = this.props.form;
    	return <Form onSubmit={this.handleSubmit}>
    		<ContentBox.HeaderToolbar header={I18n.t("account_information")} buttonsProps={[{ text: I18n.t("cancel"), onClick: this.handleReset }, { text: I18n.t("save"), htmlType: "submit" }]} />
    		<FormItem label={I18n.t("username")} labelCol={{ span: 5 }} wrapperCol={{ span: 7 }}>
    			<Input disabled name={"username"} id={"username"} value={store.getState()[ReducerKeys.USER].user.email} />
    		</FormItem>
    		<FormItem label={I18n.t("password")} labelCol={{ span: 5 }} wrapperCol={{ span: 7 }}>
    			{getFieldDecorator("oldpassword", {
    				rules: [
    					{
    						required: true,
    						message: I18n.t("requireCurrentPassword")
    					}
    				]
    			})(<Input type={"password"} placeholder={I18n.t("currentPassword")} />)}
    		</FormItem>
    		<FormItem wrapperCol={{ span: 7, offset: 5 }}>
    			<Col span={11}>
    				<FormItem>
    					{getFieldDecorator("newpassword", {
    						rules: [
    							{
    								required: true,
    								message: I18n.t("requireNewPassword")
    							},
    							{
    								validator: this.checkConfirm
    							}
    						]
    					})(<Input type={"password"} placeholder={I18n.t("newPassword")} />)}
    				</FormItem>
    			</Col>
    			<Col span={1}>
    				<span style={{ display: "inline-block", width: "100%", textAlign: "center" }} />
    			</Col>
    			<Col span={11}>
    				<FormItem>
    					{getFieldDecorator("confirmpassword", {
    						rules: [
    							{
    								required: true,
    								message: I18n.t("requireConfirmPassword")
    							},
    							{
    								validator: this.checkPassword
    							}
    						]
    					})(<Input type={"password"} placeholder={I18n.t("confirmPassword")} onBlur={this.handleConfirmBlur} />)}
    				</FormItem>
    			</Col>
    		</FormItem>
    	</Form>;
    }
}

const AccountForm = Form.create()(FormAccountAdmin);

export default AccountForm;




// WEBPACK FOOTER //
// ./src/containers/SettingPanels/AccountForm.js